<template>
  <b-modal header-close-content="" body-class="view-options-modal" id="view-options-modal" :title="$t('menubar.view')" ok-only>
    <div class="section-wrapper">
      <div class="settings-group">
        <div class="settings-group-title">{{ $t("General") }}</div>
        <div class="d-flex align-items-center">
          <b-form-checkbox v-model="vm.IsTranslationDetailViewVisible" switch>{{ $t("translationManager.isTranslationDetailViewVisible") }}</b-form-checkbox>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script setup lang="ts">
import { useUserSettings } from "@common/composable/useRootStore";
import { onMounted } from "vue";
import { watch } from "vue";
import { reactive } from "vue";

const { userSettings, saveUserSettings } = useUserSettings();

type ViewModel = {
  IsTranslationDetailViewVisible: boolean;
};

const vm = reactive<ViewModel>({
  IsTranslationDetailViewVisible: false
});

watch(
  () => vm,
  (newValue) => {
    saveUserSettings(newValue);
  },
  {
    deep: true
  }
);

watch(
  () => userSettings.value.IsTranslationDetailViewVisible,
  (newValue) => {
    Object.assign(vm, {
      IsTranslationDetailViewVisible: newValue === true || newValue === "true"
    });
  }
);

onMounted(() =>
  Object.assign(vm, {
    IsTranslationDetailViewVisible: userSettings.value.IsTranslationDetailViewVisible === true || userSettings.value.IsTranslationDetailViewVisible === "true"
  })
);
</script>
